/* eslint-disable no-undef */
import Vue from 'vue'

let countries = []

const GetCountries = (locale) => {
  const url = 'static/countries/'
  return Vue.prototype.$axios.get(url + locale + '.json')
}

const setCountries = (language) => {
  language = language || 'en'

  if (language.indexOf('_') > -1) {
    language = language.split('_')[0]
  }

  GetCountries(language)
    .then(res => {
      countries.length = 0

      res.data.forEach(country => {
        countries.push(country)
      })
    })
    .catch(err => {
      console.log(err)
    })
}
const getCountryByCode = (countryCode) => {
  return _.find(countries, function (countryObject) {
    return countryObject.code === countryCode
  })
}
const getCountryByName = (name) => {
  if (!name) {
    return ''
  }
  return _.find(countries, function (countryObject) {
    if (countryObject.name === name) {
      return countryObject
    }
  })
}
export default {
  countries,
  GetCountries,
  setCountries,
  getCountryByCode,
  getCountryByName
}



// WEBPACK FOOTER //
// ./src/plugins/factory/Countries.js